import React, { useState, useEffect } from "react";
import { useAdminAuth } from "../../auth/AdminAuthProvider";
import { useNavigate } from "react-router-dom";
import { FaUserLock } from "react-icons/fa";
import { BiSolidUserDetail } from "react-icons/bi";
import {
  FaHandHoldingDollar,
  FaUserCheck,
} from "react-icons/fa6";
import { GiPayMoney, GiTakeMyMoney } from "react-icons/gi";
import DashboardHeader from "../../../components/layout/DashboardHeader";
import Sidebar from "../../../components/layout/Sidebar";
import {
  MdCurrencyExchange,
  MdDangerous,
  MdOutlineAssuredWorkload,
} from "react-icons/md";
import CountUp from "react-countup";
import axios from "axios";
import { BASE_URL } from "../../../env";
import "./Dashboard.css";
import { GiMoneyStack } from "react-icons/gi";

const Dashboard = () => {
  const { adminUser, openSidebarToggle, toggleSidebar } = useAdminAuth();
  const navigate = useNavigate();

  const [loginCredentialCount, setLoginCredentialCount] = useState(0);
  const [blPendingMemberCount, setBlPendingMemberCount] = useState(0);
  const [jlgPendingMemberCount, setJlgPendingMemberCount] = useState(0);
  const [gplPendingMemberCount, setGplPendingMemberCount] = useState(0);
  const [blApprovedMemberCount, setBlApprovedMemberCount] = useState(0);
  const [jlgApprovedMemberCount, setJlgApprovedMemberCount] = useState(0);
  const [gplApprovedMemberCount, setGplApprovedMemberCount] = useState(0);
  const [blRejectedMemberCount, setBlRejectedMemberCount] = useState(0);
  const [jlgRejectedMemberCount, setJlgRejectedMemberCount] = useState(0);
  const [gplRejectedMemberCount, setGplRejectedMemberCount] = useState(0);
  const [blDisbursedLoanAmount, setBlDisbursedLoanAmount] = useState(0);
  const [jlgDisbursedLoanAmount, setJlgDisbursedLoanAmount] = useState(0);
  const [gplDisbursedLoanAmount, setGplDisbursedLoanAmount] = useState(0);
  const [blDisbursedLoanCount, setBlDisbursedLoanCount] = useState(0);
  const [jlgDisbursedLoanCount, setJlgDisbursedLoanCount] = useState(0);
  const [gplDisbursedLoanCount, setGplDisbursedLoanCount] = useState(0);
  const [blSecurityDepositAmount, setBlSecurityDepositAmount] = useState(0);
  const [jlgSecurityDepositAmount, setJlgSecurityDepositAmount] = useState(0);
  const [gplSecurityDepositAmount, setGplSecurityDepositAmount] = useState(0);
  const [blProcessingChargeAmount, setBlProcessingChargeAmount] = useState(0);
  const [jlgProcessingChargeAmount, setJlgProcessingChargeAmount] = useState(0);
  const [gplProcessingChargeAmount, setGplProcessingChargeAmount] = useState(0);
  const [blTotalOutstandingPrincipal, setBlTotalOutstandingPrincipal] = useState(0);
  const [jlgTotalOutstandingPrincipal, setJlgTotalOutstandingPrincipal] = useState(0);
  const [gplTotalOutstandingPrincipal, setGplTotalOutstandingPrincipal] = useState(0);
  const [blTotalInterestPaid, setBlTotalInterestPaid] = useState(0);
  const [jlgTotalInterestPaid, setJlgTotalInterestPaid] = useState(0);
  const [gplTotalInterestPaid, setGplTotalInterestPaid] = useState(0);
  const [totalRevenueInterest, setTotalRevenueInterest] = useState(0);
  const [totalRevenueProcessingFee, setTotalRevenueProcessingFee] = useState(0);
  const [fundingAgencyData, setFundingAgencyData] = useState([]);

  const OpenSidebar = () => {
    toggleSidebar();
  };

  const handleLoginCredentialsClick = () => {
    navigate("/logincredential");
  };

  useEffect(() => {
    const fetchCounts = async (userId) => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/dashboardcount?userId=${userId}`
        );
        setLoginCredentialCount(response.data.userCount);
        setBlPendingMemberCount(response.data.blPendingMemberCount);
        setJlgPendingMemberCount(response.data.jlgPendingMemberCount);
        setGplPendingMemberCount(response.data.gplPendingMemberCount);
        setBlApprovedMemberCount(response.data.blApprovedMemberCount);
        setJlgApprovedMemberCount(response.data.jlgApprovedMemberCount);
        setGplApprovedMemberCount(response.data.gplApprovedMemberCount);
        setBlRejectedMemberCount(response.data.blRejectedMemberCount);
        setJlgRejectedMemberCount(response.data.jlgRejectedMemberCount);
        setGplRejectedMemberCount(response.data.gplRejectedMemberCount);
        setBlDisbursedLoanAmount(response.data.blDisbursedLoanAmount);
        setJlgDisbursedLoanAmount(response.data.jlgDisbursedLoanAmount);
        setGplDisbursedLoanAmount(response.data.gplDisbursedLoanAmount);
        setBlDisbursedLoanCount(response.data.blDisbursedLoanCount);
        setJlgDisbursedLoanCount(response.data.jlgDisbursedLoanCount);
        setGplDisbursedLoanCount(response.data.gplDisbursedLoanCount);
        setBlSecurityDepositAmount(response.data.blSecurityDepositAmount);
        setJlgSecurityDepositAmount(response.data.jlgSecurityDepositAmount);
        setGplSecurityDepositAmount(response.data.gplSecurityDepositAmount);
        setBlProcessingChargeAmount(response.data.blProcessingChargeAmount);
        setJlgProcessingChargeAmount(response.data.jlgProcessingChargeAmount);
        setGplProcessingChargeAmount(response.data.gplProcessingChargeAmount);
        setBlTotalOutstandingPrincipal(response.data.blTotalOutstandingPrincipal);
        setJlgTotalOutstandingPrincipal(response.data.jlgTotalOutstandingPrincipal);
        setGplTotalOutstandingPrincipal(response.data.gplTotalOutstandingPrincipal);
        setBlTotalInterestPaid(response.data.blTotalInterestPaid);
        setJlgTotalInterestPaid(response.data.jlgTotalInterestPaid);
        setGplTotalInterestPaid(response.data.gplTotalInterestPaid);
        setTotalRevenueInterest(response.data.totalRevenueInterest || 0);
        setTotalRevenueProcessingFee(response.data.totalRevenueProcessingFee || 0);
        setFundingAgencyData(response.data.fundingAgencyData || []);
      } catch (error) {
        console.error("Error fetching counts:", error);
      }
    };

    if (adminUser?.user?.id) {
      fetchCounts(adminUser.user.id);
    }
  }, [adminUser]);

  return (
    <section className="master-layout">
      <div className="master-sidebar-wrapper">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
      </div>

      <div className="master-content-wrapper">
        <div className="master-header-wrapper">
          <DashboardHeader OpenSidebar={OpenSidebar} />
        </div>

        <div className="master-card-container dashboard-container">
          <div className="dashboard-main-content">
            <div className="dashboard-grid">
              {adminUser?.userType === "superadmin" && (
                <div style={{ position: "relative" }}>
                  <div
                    className="dashboardcard bg-c-blue dashboard-card container-crd"
                    onClick={handleLoginCredentialsClick}
                  >
                    <div className="dashboardCard-image">
                      <FaUserLock
                        className="dashboardCard-icon content-crd"
                        style={{ color: "white" }}
                      />
                    </div>
                    <div className="counter content-crd">
                      <CountUp
                        start={0}
                        end={loginCredentialCount}
                        duration={2.5}
                      />
                    </div>
                    <div className="dashboardCard-block content-crd">
                      <p style={{ fontWeight: "500" }}>Login Credentials</p>
                    </div>
                  </div>
                </div>
              )}
              <div style={{ position: "relative" }}>
                <div
                  className="dashboardcard bg-c-yellow dashboard-card container-crd"
                  onClick={() =>
                    navigate("/memberdetails", {
                      state: {
                        manager: "",
                        filterStatus: "",
                        loanType: "Business Loan",
                        isActive: "Member Details",
                      },
                    })
                  }
                >
                  <div className="dashboardCard-image content-crd">
                    <BiSolidUserDetail
                      className="dashboardCard-icon"
                      style={{ color: "white" }}
                    />
                  </div>
                  <div className="counter content-crd">
                    <CountUp
                      start={0}
                      end={blPendingMemberCount + jlgPendingMemberCount + gplPendingMemberCount}
                      duration={2.5}
                    />
                  </div>
                  <div className="dashboardCard-block content-crd">
                    <p style={{ fontWeight: "500" }}>Pending Member Details</p>
                  </div>
                  <div className="tooltip-content">
                    <p>BL Members: {blPendingMemberCount}</p>
                    <p>JLG Members: {jlgPendingMemberCount}</p>
                    <p>Gpl Members: {gplPendingMemberCount}</p>
                  </div>
                </div>
              </div>

              <div style={{ position: "relative" }}>
                <div
                  className="dashboardcard bg-c-green dashboard-card container-crd"
                  onClick={() =>
                    navigate("/memberdetails", {
                      state: {
                        filterStatus: "approved",
                        loanType: "Business Loan",
                        isActive: "Approved",
                      },
                    })
                  }
                >
                  <div className="dashboardCard-image content-crd">
                    <FaUserCheck
                      className="dashboardCard-icon"
                      style={{ color: "white" }}
                    />
                  </div>
                  <div className="counter content-crd">
                    <CountUp
                      start={0}
                      end={blApprovedMemberCount + jlgApprovedMemberCount + gplApprovedMemberCount}
                      duration={2.5}
                    />
                  </div>
                  <div className="dashboardCard-block content-crd">
                    <p style={{ fontWeight: "500" }}>Approved Member Details</p>
                  </div>
                  <div className="tooltip-content">
                    <p>BL Approved: {blApprovedMemberCount}</p>
                    <p>JLG Approved: {jlgApprovedMemberCount}</p>
                    <p>GPL Approved: {gplApprovedMemberCount}</p>
                  </div>
                </div>
              </div>

              <div style={{ position: "relative" }}>
                <div
                  className="dashboardcard bg-c-pink dashboard-card container-crd"
                  onClick={() =>
                    navigate("/memberdetails", {
                      state: {
                        filterStatus: "rejected",
                        loanType: "Business Loan",
                        isActive: "Rejected",
                      },
                    })
                  }
                >
                  <div className="dashboardCard-image content-crd">
                    <MdDangerous
                      className="dashboardCard-icon"
                      style={{ color: "white" }}
                    />
                  </div>
                  <div className="counter content-crd">
                    <CountUp
                      start={0}
                      end={blRejectedMemberCount + jlgRejectedMemberCount + gplRejectedMemberCount}
                      duration={2.5}
                    />
                  </div>
                  <div className="dashboardCard-block content-crd">
                    <p style={{ fontWeight: "500" }}>Rejected Member Details</p>
                  </div>
                  <div className="tooltip-content">
                    <p>BL Rejected: {blRejectedMemberCount}</p>
                    <p>JLG Rejected: {jlgRejectedMemberCount}</p>
                    <p>GPL Rejected: {gplRejectedMemberCount}</p>
                  </div>
                </div>
              </div>

              <div style={{ position: "relative" }}>
                <div className="dashboardcard bg-c-blue dashboard-card container-crd">
                  <div className="dashboardCard-image content-crd">
                    <FaHandHoldingDollar
                      className="dashboardCard-icon"
                      style={{ color: "white" }}
                    />
                  </div>
                  <div className="counter content-crd">
                    <CountUp
                      start={0}
                      end={blDisbursedLoanAmount + jlgDisbursedLoanAmount + gplDisbursedLoanAmount}
                      duration={2.5}
                    />
                  </div>
                  <div className="dashboardCard-block content-crd">
                    <p style={{ fontWeight: "500" }}>Total Disbursement</p>
                  </div>
                  <div className="tooltip-content">
                    <p>BL Disbursement: ₹{blDisbursedLoanAmount}</p>
                    <p>JLG Disbursement: ₹{jlgDisbursedLoanAmount}</p>
                    <p>GPL Disbursement: ₹{gplDisbursedLoanAmount}</p>
                  </div>
                </div>
              </div>

              <div style={{ position: "relative" }}>
                <div className="dashboardcard bg-c-yellow dashboard-card container-crd">
                  <div className="dashboardCard-image content-crd">
                    <GiPayMoney
                      className="dashboardCard-icon"
                      style={{ color: "white" }}
                    />
                  </div>
                  <div className="counter content-crd">
                    <CountUp
                      start={0}
                      end={blDisbursedLoanCount + jlgDisbursedLoanCount + gplDisbursedLoanCount}
                      duration={2.5}
                    />
                  </div>
                  <div className="dashboardCard-block content-crd">
                    <p style={{ fontWeight: "500" }}>Total Borrowers</p>
                  </div>
                  <div className="tooltip-content">
                    <p>BL Borrowers: {blDisbursedLoanCount}</p>
                    <p>JLG Borrowers: {jlgDisbursedLoanCount}</p>
                    <p>GPL Borrowers: {gplDisbursedLoanCount}</p>
                  </div>
                </div>
              </div>

              <div style={{ position: "relative" }}>
                <div className="dashboardcard bg-c-green dashboard-card container-crd">
                  <div className="dashboardCard-image content-crd">
                    <MdOutlineAssuredWorkload
                      className="dashboardCard-icon"
                      style={{ color: "white" }}
                    />
                  </div>
                  <div className="counter content-crd">
                    <CountUp
                      start={0}
                      end={blSecurityDepositAmount + jlgSecurityDepositAmount + gplSecurityDepositAmount}
                      duration={2.5}
                    />
                  </div>
                  <div className="dashboardCard-block content-crd">
                    <p style={{ fontWeight: "500" }}>Security Deposit</p>
                  </div>
                  <div className="tooltip-content">
                    <p>BL Security Deposit: ₹{blSecurityDepositAmount}</p>
                    <p>JLG Security Deposit: ₹{jlgSecurityDepositAmount}</p>
                    <p>GPL Security Deposit: ₹{gplSecurityDepositAmount}</p>
                  </div>
                </div>
              </div>

              <div style={{ position: "relative" }}>
                <div className="dashboardcard bg-c-pink dashboard-card container-crd">
                  <div className="dashboardCard-image content-crd">
                    <MdCurrencyExchange
                      className="dashboardCard-icon"
                      style={{ color: "white" }}
                    />
                  </div>
                  <div className="counter content-crd">
                    <CountUp
                      start={0}
                      end={blProcessingChargeAmount + jlgProcessingChargeAmount + gplProcessingChargeAmount}
                      duration={2.5}
                    />
                  </div>
                  <div className="dashboardCard-block content-crd">
                    <p style={{ fontWeight: "500" }}>Processing Charge</p>
                  </div>
                  <div className="tooltip-content">
                    <p>BL Processing Charge: ₹{blProcessingChargeAmount}</p>
                    <p>JLG Processing Charge: ₹{jlgProcessingChargeAmount}</p>
                    <p>GPL Processing Charge: ₹{gplProcessingChargeAmount}</p>
                  </div>
                </div>
              </div>

              <div style={{ position: "relative" }}>
                <div className="dashboardcard bg-c-blue dashboard-card container-crd">
                  <div className="dashboardCard-image content-crd">
                    <GiMoneyStack
                      className="dashboardCard-icon"
                      style={{ color: "white" }}
                    />
                  </div>
                  <div className="counter content-crd">
                    <CountUp
                      start={0}
                      end={blTotalOutstandingPrincipal + jlgTotalOutstandingPrincipal + gplTotalOutstandingPrincipal}
                      duration={2.5}
                    />
                  </div>
                  <div className="dashboardCard-block content-crd">
                    <p style={{ fontWeight: "500" }}>Outstanding Principal</p>
                  </div>
                  <div className="tooltip-content">
                    <p>BL Outstanding Principal: ₹{blTotalOutstandingPrincipal}</p>
                    <p>JLG Outstanding Principal: ₹{jlgTotalOutstandingPrincipal}</p>
                    <p>Gpl Outstanding Principal: ₹{gplTotalOutstandingPrincipal}</p>
                  </div>
                </div>
              </div>

              <div style={{ position: "relative" }}>
                <div className="dashboardcard bg-c-yellow dashboard-card container-crd">
                  <div className="dashboardCard-image content-crd">
                    <GiTakeMyMoney
                      className="dashboardCard-icon"
                      style={{ color: "white" }}
                    />
                  </div>
                  <div className="counter content-crd">
                    <CountUp
                      start={0}
                      end={blTotalInterestPaid + jlgTotalInterestPaid + gplTotalInterestPaid}
                      duration={2.5}
                    />
                  </div>
                  <div className="dashboardCard-block content-crd">
                    <p style={{ fontWeight: "500" }}>Interest Collected</p>
                  </div>
                  <div className="tooltip-content">
                    <p>BL Interest Collected: ₹{blTotalInterestPaid}</p>
                    <p>JLG Interest Collected: ₹{jlgTotalInterestPaid}</p>
                    <p>Gpl Interest Collected: ₹{gplTotalInterestPaid}</p>
                  </div>
                </div>
              </div>

              <div style={{ position: "relative" }}>
                <div className="dashboardcard bg-c-green dashboard-card container-crd">
                  <div className="dashboardCard-image content-crd">
                    <GiMoneyStack
                      className="dashboardCard-icon"
                      style={{ color: "white" }}
                    />
                  </div>
                  <div className="counter content-crd">
                    <CountUp
                      start={0}
                      end={totalRevenueInterest}
                      duration={2.5}
                      separator=","
                      decimals={2}
                    />
                  </div>
                  <div className="dashboardCard-block content-crd">
                    <p style={{ fontWeight: "500" }}>Revenue Interest</p>
                  </div>
                  <div className="tooltip-content">
                    {fundingAgencyData && fundingAgencyData.length > 0 ? (
                      fundingAgencyData.map((agency, index) => (
                        <p key={index}>
                          {agency.name}: ₹{(agency.revenueInterest || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                        </p>
                      ))
                    ) : (
                      <p>No Data Available</p>
                    )}
                  </div>
                </div>
              </div>

              <div style={{ position: "relative" }}>
                <div className="dashboardcard bg-c-pink dashboard-card container-crd">
                  <div className="dashboardCard-image content-crd">
                    <MdCurrencyExchange
                      className="dashboardCard-icon"
                      style={{ color: "white" }}
                    />
                  </div>
                  <div className="counter content-crd">
                    <CountUp
                      start={0}
                      end={totalRevenueProcessingFee}
                      duration={2.5}
                      separator=","
                      decimals={2}
                    />
                  </div>
                  <div className="dashboardCard-block content-crd">
                    <p style={{ fontWeight: "500" }}>Revenue Processing Fee</p>
                  </div>
                  <div className="tooltip-content">
                    {fundingAgencyData && fundingAgencyData.length > 0 ? (
                      fundingAgencyData.map((agency, index) => (
                        <p key={index}>
                          {agency.name}: ₹{(agency.revenueProcessingFee || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                        </p>
                      ))
                    ) : (
                      <p>No Data Available</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
